import { apiErrorCode } from '@d-orca/shared/client/apis';

/** A failure notice's copy — i18n keys. */
export interface IWriteFailureCopy {
  title: string;
  sub: string;
}

/**
 * The copy for a write the server refused ON PURPOSE, or null for any other
 * failure. A take-back on an activity Trusstor holds as complete is refused
 * (QA F-50: Trusstor would detach the area), so the notice says why rather
 * than blaming the connection. One answer for every surface that reports area
 * writes: the Progress Tracker and the task drawer.
 */
export function writeRefusalCopy(error: unknown): IWriteFailureCopy | null {
  return apiErrorCode(error) === 'AREA_GROUP_COMPLETE'
    ? { title: 'activities.tracker.groupComplete', sub: 'activities.tracker.groupCompleteSub' }
    : null;
}
